import React, { Component } from "react";
import * as icons from "@ant-design/icons";

import "./index.less";

export default class Icon extends Component {

  render() {
    const { value } = this.props
    if (!value || !icons[value]) {
      return "";
    }
    const Icon = icons[value];
    return <Icon {...this.props} />;
  };

};
